import React, { useState } from 'react';
import './App.css';
import HeartBackground from './components/HeartBackground';

function App() {
  const [accepted, setAccepted] = useState(false);
  const [noButtonSize, setNoButtonSize] = useState(1); // Scale factor starting at 100%
  const [yesButtonScale, setYesButtonScale] = useState(1); // Scale factor for yes button
  const [noButtonPosition, setNoButtonPosition] = useState({ top: 'auto', left: 'auto', position: 'static' });

  // Use environment variables with fallback defaults
  const proposerName = process.env.REACT_APP_PROPOSER_NAME || "Your Name";
  const receiverName = process.env.REACT_APP_RECEIVER_NAME || "Special Someone";

  const handleYesClick = () => {
    setAccepted(true);
  };

  const handleNoClick = () => {
    // Shrink the "No" button by 15% with each click, minimum size 10% of original
    setNoButtonSize(prevSize => Math.max(0.1, prevSize - 0.15));

    // Move to a random position
    const randomTop = Math.random() * 80 + 10; // 10% to 90% height
    const randomLeft = Math.random() * 80 + 10; // 10% to 90% width

    setNoButtonPosition({
      top: `${randomTop}%`,
      left: `${randomLeft}%`,
      position: 'absolute' // Switch to absolute positioning
    });
  };

  const handleYesHover = () => {
    // Make the "Yes" button slightly bigger when hovered
    setYesButtonScale(1.1);
  };

  const handleYesLeave = () => {
    // Return the "Yes" button to normal size when not hovered
    setYesButtonScale(1);
  };

  return (
    <div className="App">
      <HeartBackground />
      {!accepted ? (
        <div className="proposal-container">
          <h1 className="title">Will You Be My Valentine? 🌹</h1>
          <p className="message">{proposerName} has a question for {receiverName}...</p>

          <div className="buttons-container">
            <button
              className="yes-button"
              onClick={handleYesClick}
              onMouseEnter={handleYesHover}
              onMouseLeave={handleYesLeave}
              style={{
                transform: `scale(${yesButtonScale})`,
                transition: 'transform 0.2s ease'
              }}
            >
              Yes 💖
            </button>

            <button
              className="no-button"
              onClick={handleNoClick}
              style={{
                transform: `scale(${noButtonSize})`,
                transition: 'all 0.3s ease',
                ...noButtonPosition
              }}
            >
              No 😢
            </button>
          </div>
        </div>
      ) : (
        <div className="acceptance-container">
          <h1 className="acceptance-title">Yay! I knew you'd say Yes! 💘</h1>
          <p className="acceptance-message">{receiverName} & {proposerName} forever!</p>
          <div className="image-container">
            <img
              src="https://media.giphy.com/media/26BRv0ThflsHCqDrG/giphy.gif"
              alt="Love Gif"
              className="love-gif"
            />
          </div>
        </div>
      )}
      <footer className="footer">
        Made with ❤️ by KSauraj
      </footer>
    </div>
  );
}

export default App;